import { useQuery } from '@eika-infrastruktur/react-query';

import { getSigningOrders } from '../services/signingOrdersService';

export const useSigningOrders = (includeInFlow = false) =>
    useQuery('signingOrders', () => getSigningOrders(includeInFlow));
